module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/$.add-to-unscopables.js
// module id = 1004
// module chunks = 0